export default __webpack_public_path__ + "static/media/readingWorld@2x.5374157e.png";